import React, { useState, useEffect } from "react";
import { TextArea, NumericTextBox, Input } from "@progress/kendo-react-inputs";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { filterBy } from "@progress/kendo-data-query";
import { useNominalsBySubType } from "services/nominalsService";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Label } from "@progress/kendo-react-labels";
import { Button } from "@progress/kendo-react-buttons";
import { useSelector, useDispatch } from "react-redux";
import MattersCombobox from "../Postings/MattersComboBox";
import Modalposting from "../Postings/PostingModal";
import { DocumentsUpload } from "../Postings/DcoumentsUpload";
import { FILES_CONTEXT, useFiles } from "services/filesDownloadService";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { useUploadForm } from "components/fileUploadHook";
import { onFileUpload } from "services/fileDataService";
import CalenderCustomToggleButton from "components/common/CalenderCustomToogleButton";
import { ComboBoxComponent } from "pages/ChitRequest/ChitRequestComponents";
import styles from "pages/ChitRequest/ChitRequest.module.scss";
import { getMatterAllInfo } from "api";
import { editPosting } from "api/accountsAPI";
import { toast } from "react-toastify";
import { useActiveVats } from "services/vatService";
import { useActiveFeeEarner } from "services/userService";
import { getPostingTypes } from "services/postingTypesService";
import { useActiveSuppliers } from "services/supplierService";

const EditPosting = (props) => {
  const { postingInfo } = props;
  const [list, setList] = useState([]);
  const { data: activevatsdata = [] } = useActiveVats();
  const [resetDocs, setresetDocs] = useState(false);
  const { clearFile } = useFiles(FILES_CONTEXT.CHIT_REQUEST);

  const date = new Date();
  const [type, settype] = useState("");
  const [vatvalue, setvatvalue] = useState();
  const [matterref, setmatterref] = useState(postingInfo.matterID || null);
  const [feeearnerref, setfeeearnerref] = useState();
  const [matter, setMatter] = useState("");
  const [branch, setbranch] = useState({ branchId: "" });
  const [nominal, setnominal] = useState({ nominalRef: "" });
  const [suppliervalue, setsuppliervalue] = useState({ supplierRef: "" });
  const [errorModal, setErrorModal] = useState(false);
  const [officevalue, setofficevalue] = useState(postingInfo?.officeBank || "");
  const [clientvalue, setclientvalue] = useState(postingInfo?.clientBank || "");
  const [ddavalue, setddavalue] = useState(postingInfo?.ddaBank || "");
  const [reference, setreference] = useState(postingInfo?.reference || "");
  const [payee, setpayee] = useState(postingInfo?.payee || "");
  const [payer, setpayer] = useState(postingInfo?.payer || "");
  const [vatamount, setvatamount] = useState(postingInfo?.vatAmount || 0);
  const [netamount, setnetamount] = useState(postingInfo?.netAmount || 0);
  const { data: suppliersdata } = useActiveSuppliers();
  const [grossamount, setgrossamount] = useState("");
  const [resetmatter, setresetmatter] = useState(false);
  const [details, setdetails] = useState(postingInfo?.details || "");
  const [dateselector, setdateselector] = useState(
    new Date(postingInfo?.date) || date
  );
  const [counselfee, setcounselfee] = useState(
    postingInfo?.isCounselFee || false
  );
  const [statepreserver, setstatepreserver] = useState(false);
  const [modalvalue, setmodalvalue] = useState(false);
  const [validation_message, setvalidation_message] = useState(false);
  const [documentUpload, setDocumentsUpload] = useState(false);
  const [value, setValue] = useState("");
  const dispatch = useDispatch();

  const fetchPostingData = async () => {
    try {
      const postingData = await getPostingTypes("chits");
      if (!Array.isArray(postingData) || postingData.length === 0) return;

      const displayFields = postingData[0]?.displayFields || [];
      setList(displayFields.map((item) => item.name));
    } catch (error) {
      console.error("Failed to fetch posting types:", error);
    }
  };

  useEffect(() => {
    fetchPostingData();
  }, [props.name]);

  const onChange = (event) => {
    setValue(event.value);
  };
  const onChangesupplier = (event) => {
    if (event !== undefined && event !== null) {
      setsuppliervalue(event.value);
    }
  };
  const onChangeofficebank = (event) => {
    if (event !== undefined && event !== null) {
      setofficevalue(event.value);
    }
  };
  const onChangeclientbank = (event) => {
    if (event !== undefined && event !== null) {
      setclientvalue(event.value);
    }
  };
  const onChangeddabank = (event) => {
    if (event !== undefined && event !== null) {
      setddavalue(event.value);
    }
  };
  const { data: feeearnerdata } = useActiveFeeEarner();

  useEffect(() => {
    getMatterInfo();
    feeEarnerValue();
  }, []);
  // set Initial feeEarner value
  const feeEarnerValue = () => {
    if (postingInfo.feeEarnerRef !== null) {
      const feeEarner = feeearnerdata.find(
        (item) => item.userRef === postingInfo.feeEarnerRef
      );
      setfeeearnerref(feeEarner);
    }
    return null;
  };

  const getMatterInfo = async () => {
    const matterInfo = await getMatterAllInfo(postingInfo?.matterID);
    setMatter(matterInfo.data.data);
  };

  const { data: officeNominals } = useNominalsBySubType(
    "BalanceSheet_OfficeBank"
  );
  const { data: clientNominals } = useNominalsBySubType(
    "BalanceSheet_ClientBank"
  );
  const { data: ddaNominals } = useNominalsBySubType("BalanceSheet_DDABank");

  const officeapidata = officeNominals || [];
  const clientapidata = clientNominals || [];
  const ddaapidata = ddaNominals || [];

  const { data: expenseNominals } = useNominalsBySubType(
    "ProfitAndLoss_Expense"
  );
  const nominallist = expenseNominals || [];

  useEffect(() => {
    if (statepreserver === false) {
      setTimeout(() => {
        setvatsData(activevatsdata.slice());
        setfeeearnerData(feeearnerdata.slice());
        setsuppliersdata(suppliersdata.slice());
        setnominaldata(nominallist.slice());
        setofficedata(officeapidata.slice());
        setclientdata(clientapidata.slice());
        setddadata(ddaapidata.slice());
        setstatepreserver(true);
      }, 2000);
    }
  }, [
    feeearnerdata,
    activevatsdata,
    suppliersdata,
    officeapidata,
    clientapidata,
    ddaapidata,
  ]);

  const [vatsdata, setvatsData] = useState();
  const [feeearner, setfeeearnerData] = useState();
  const [suppliers, setsuppliersdata] = useState();
  const [nominaldata, setnominaldata] = useState();
  const [officedata, setofficedata] = useState();
  const [clientdata, setclientdata] = useState();
  const [ddadata, setddadata] = useState();

  const filterData = (filter) => {
    const datas = activevatsdata.slice();
    return filterBy(datas, filter);
  };

  const filterChange = (event) => {
    setvatsData(filterData(event.filter));
  };
  const filtersupplier = (filter) => {
    const data = suppliersdata.slice();
    return filterBy(data, filter);
  };
  const filterChangesupplier = (event) => {
    setsuppliersdata(filtersupplier(event.filter));
  };

  const filterofficebank = (filter) => {
    const data = officeapidata.slice();
    return filterBy(data, filter);
  };
  const filterChangeofficebank = (event) => {
    setofficedata(filterofficebank(event.filter));
  };
  const filterclientbank = (filter) => {
    const data = clientapidata.slice();
    return filterBy(data, filter);
  };
  const filterChangeclientbank = (event) => {
    setofficedata(filterclientbank(event.filter));
  };
  const filterddabank = (filter) => {
    const data = ddaapidata.slice();
    return filterBy(data, filter);
  };
  const filterChangeddabank = (event) => {
    setofficedata(filterddabank(event.filter));
  };
  const filterfeeearnerData = (filter) => {
    const data = feeearnerdata.slice();
    return filterBy(data, filter);
  };
  const filterfeeearner = (event) => {
    setfeeearnerData(filterfeeearnerData(event.filter));
  };
  const filternominalData = (filter) => {
    const data = nominallist.slice();
    return filterBy(data, filter);
  };
  const filternominal = (event) => {
    setnominaldata(filternominalData(event.filter));
  };

  const onChangevat = (event) => {
    setvatvalue(event.value);
  };
  const calculatevatamount = () => {
    if (vatvalue !== undefined && vatvalue !== null) {
      const vatamount = netamount * (vatvalue.rate / 100);
      setvatamount(vatamount);
    }
  };
  useEffect(() => {
    calculatevatamount();
  }, [vatvalue, netamount]);
  const onChangedateselect = (event) => {
    setdateselector(event.value);
  };

  const onChangefeeearner = (event) => {
    setfeeearnerref(event.value);
  };

  const onChangenominal = (event) => {
    setnominal(event.value);
  };

  const closeDialog = () => {
    props.cancelViewPosting();
    props.cancelEdit();
  };

  const handlesubmit = async (e) => {
    e.preventDefault();
    // if (props.name === undefined) {
    //   if (filesChitRequest[0] !== undefined) {
    //     const docsId = [];
    //     filesChitRequest.map((item) => {
    //       docsId.push(item.fileID);
    //     });
    // data[0].DocumentFiles = docsId;
    //   }
    // }
    // if (IS_MODAL) {
    // data[0].matterID = props.matter?.matterId;
    // }
    // dispatch(createposting(data));

    const data = {
      date: dateselector,
      reference: reference,
      netAmount: netamount,
      vatAmount: vatamount,
      vatCode: postingInfo?.vatCode,
      vatRate: postingInfo?.vatRate,
      feeEarnerRef: feeearnerref?.userRef,
      details: details,
      transactionPeriod: postingInfo?.transactionPeriod,
      isCounselFee: counselfee,
      payer: payer,
      payee: payee,
      officeBank: officevalue,
      clientBank: clientvalue || "",
      ddaBank: ddavalue || "",
      costCentre: postingInfo?.costCentre,
      documentFiles: postingInfo?.documentFiles,
      //   postedDocuments: [
      //     {
      //       documentId: 0,
      //       active: true,
      //     },
      //   ],
    };
    try {
      await editPosting(props?.transNo, data);
      closeDialog();
      props.reloadPosting();
      toast.success("Posting edited successfully");
    } catch (error) {
    }
  };
  const resetfields = () => {
    setvalidation_message(false);
    setgrossamount("");
    setreference("");
    setvatamount("");
    // setmatterref(undefined);
    setpayee("");
    setpayer("");
    setdetails("");
    setnetamount(0);
    setfeeearnerref(null);
    setdateselector(date);
    setvatvalue(null);
    setofficevalue(null);
    setclientvalue(null);
    setddavalue(null);
    setsuppliervalue({ supplierRef: "" });
    setnominal({ nominalRef: "" });
    setbranch({ branchId: "" });
    setsuppliersdata(suppliersdata.slice());
    setvatsData(activevatsdata.slice());
    setfeeearnerData(feeearnerdata.slice());
    setresetDocs(!resetDocs);
    setcounselfee(false);
    clearFile();
  };

  const { isSuccess, uploadForm, progress } = useUploadForm();

  const [filesData, setFilesData] = React.useState([]);

  const handleUpload = async (e) => {
    let data = onFileUpload(e);
    setFilesData([...filesData, data]);

    const parameters = {
      documentType: "Posting",
      matterId: postingInfo.matterID || "",
      supplierRef: suppliervalue.supplierRef || "",
      nominalRef: nominal.nominalRef || "",
    };
    const dataChoosen = await uploadForm(data, e.target.files[0], parameters);
    data.fileID = dataChoosen.data.data.fileID;
  };
  const onFileRemove = (fileId) => {
    setFilesData((prev) => prev.filter((file) => file.fileID !== fileId));
  };

  const comboBoxesInfo = [
    {
      key: "OfficeBank",
      label: "Office Bank",
      condition: officevalue === undefined,
      disabled: true,
      value: officevalue,
      placeholder: "Search Office Bank",
    },
    {
      key: "SupplierRef",
      label: "Supplier Ref",
      condition: suppliervalue.supplierRef === "",
      data: suppliers,
      onFilterChange: filterChangesupplier,
      value: suppliervalue,
      field: "display",
      onChange: onChangesupplier,
      placeholder: "Search Supplier Ref",
    },
    {
      key: "ClientBank",
      label: "Client Bank",
      condition: clientvalue === undefined,
      data: clientdata,
      onFilterChange: filterChangeclientbank,
      value: clientvalue,
      onChange: onChangeclientbank,
      placeholder: "Search Client Bank",
    },
    {
      key: "DDABank",
      label: "DDA Bank",
      condition: ddavalue === undefined,
      data: ddadata,
      onFilterChange: filterChangeddabank,
      value: ddavalue,
      onChange: onChangeddabank,
      placeholder: "Search DDA Bank",
    },
    {
      key: "NominalRef",
      label: "Nominal Ref",
      condition: nominal.nominalRef === "",
      data: nominaldata,
      onFilterChange: filternominal,
      value: nominal,
      onChange: onChangenominal,
      placeholder: "Search Nominal Ref",
    },
  ];

  const EditPostingContent = () => {
    return (
      <div className={`h-100 ${styles["main-container"]}`}>
        <div className="bgForm overflow-auto">
          <div
            className="px-lg-5 px-3 "
            style={{
              maxHeight: "auto",
              maxWidth: "950px",
              overflow: "auto",
            }}
          >
            <form onSubmit={handlesubmit}>
              <div className="mt-4 px-2 d-flex flex-column">
                <div className="d-flex flex-column mb-2">
                  <Label className="label mb-1">Posting Type</Label>
                  <DropDownList
                    className={`${styles["input-styles"]}`}
                    iconClassName="wa"
                    value={`${postingInfo.postingType} - ${props.postingName}`}
                    disabled
                  />
                </div>
                <div className="d-flex flex-column">
                  <Label className="label mb-1">Matter</Label>
                  <MattersCombobox
                    className={`${styles["input-styles"]}`}
                    disabled
                    error={validation_message && !matterref}
                    value={matter}
                  />
                </div>
                <div className="d-flex flex-column mt-2">
                  <Label className="label mb-1">Date</Label>
                  <DatePicker
                    className={`${styles["input-styles"]} px-2`}
                    value={dateselector}
                    width={280}
                    onChange={onChangedateselect}
                    toggleButton={CalenderCustomToggleButton}
                  />
                </div>

                <div className="d-flex">
                  {list.includes("Reference") && (
                    <div className="d-flex flex-column mt-2 me-5">
                      <Label className="label mb-1">Reference</Label>
                      <Input
                        className={`${styles["input-styles"]}`}
                        value={reference}
                        onChange={(e) => {
                          setreference(e.target.value);
                        }}
                        placeholder={"Add Reference"}
                      />
                    </div>
                  )}
                  <div className="d-flex flex-column">
                    {comboBoxesInfo.map(
                      ({
                        key,
                        label,
                        condition,
                        data,
                        onFilterChange,
                        value,
                        onChange,
                        field,
                        placeholder,
                        disabled,
                      }) =>
                        list.includes(key) ? (
                          <ComboBoxComponent
                            key={key}
                            label={label}
                            className={`${styles["input-styles"]}`}
                            data={data}
                            textField={field || "display"}
                            filterable={true}
                            onFilterChange={onFilterChange}
                            value={value}
                            onChange={onChange}
                            placeholder={placeholder}
                            disabled={disabled}
                          />
                        ) : null
                    )}
                  </div>
                </div>
                <div className="d-flex mt-2">
                  {list.includes("NetAmount") && (
                    <div className="d-flex flex-column me-5 ">
                      <Label className="label mb-1">Net amount</Label>
                      <NumericTextBox
                        value={netamount}
                        className={`${styles["input-styles"]} right-align`}
                        disabled
                        spinners={false}
                        format="n2"
                        placeholder="0.00"
                      />
                    </div>
                  )}
                  <div className="d-flex">
                    {list.includes("VatCode") && (
                      <div className="d-flex flex-column me-3">
                        <Label className="label mb-1">VAT</Label>
                        <ComboBox
                          className={`${styles["small-inputbox"]}`}
                          data={activevatsdata}
                          textField={"display"}
                          filterable={true}
                          onFilterChange={filterChange}
                          value={vatvalue}
                          onChange={onChangevat}
                          placeholder={"Code"}
                        />
                      </div>
                    )}
                    {list.includes("VatAmount") && (
                      <div className="d-flex flex-column">
                        <Label className="label mb-1">VAT Amount</Label>
                        <NumericTextBox
                          className={`${styles["small-inputbox"]} right-align`}
                          value={vatamount}
                          readOnly={true}
                          placeholder="0.00"
                          spinners={false}
                          format="n2"
                        />
                      </div>
                    )}
                  </div>
                </div>
                <div className="d-flex between mt-2">
                  {list.includes("FeeEarnerRef") && (
                    <div className="d-flex flex-column me-5">
                      <Label className="label mb-1">Fee Earner</Label>
                      <ComboBox
                        className={`${styles["input-styles"]}`}
                        data={feeearner}
                        iconClassName="wa"
                        textField={`representation`}
                        filterable
                        onFilterChange={filterfeeearner}
                        placeholder={"Search Fee Earner"}
                        value={feeearnerref}
                        onChange={onChangefeeearner}
                      />
                    </div>
                  )}
                  <div className="d-flex flex-column">
                    {list.includes("Payer") && (
                      <div className="d-flex flex-column">
                        <Label className="label mb-1">Payer</Label>
                        <div className="validator">
                          <Input
                            value={payer}
                            className={`${styles["input-styles"]}`}
                            onChange={(e) => {
                              setpayer(e.target.value);
                            }}
                            placeholder={"Add Payer"}
                          ></Input>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="d-flex flex-column">
                    {list.includes("Payee") && (
                      <div className="d-flex flex-column">
                        <Label className="label mb-1">Payee</Label>
                        <div className="validator">
                          <Input
                            className={`${styles["input-styles"]}`}
                            value={payee}
                            onChange={(e) => {
                              setpayee(e.target.value);
                            }}
                            placeholder={"Add Payee"}
                          ></Input>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="d-flex flex-column mt-2">
                  <Label className="label mb-1">Details</Label>
                  <TextArea
                    value={details}
                    className={`${styles["details-textbox"]}`}
                    rows={5}
                    multiple={true}
                    placeholder="Enter Details"
                    onChange={(e) => {
                      setdetails(e.target.value);
                    }}
                  />
                </div>
                <div className="mt-1 d-flex justify-content-start me-5">
                  <DocumentsUpload
                    open={documentUpload}
                    value={postingInfo?.postingType}
                    type={"Edit Posting"}
                    resetDocs={resetDocs}
                    progress={progress}
                    filesData={filesData}
                    onFileRemove={onFileRemove}
                    onError={() => {
                      const newFiles = filesData.splice(filesData.length, 1);
                      setFilesData([...newFiles]);
                    }}
                    onUpload={handleUpload}
                  />
                </div>
              </div>
              <Modalposting
                value={modalvalue}
                reset={() => {
                  resetfields();
                }}
                closeModal={() => {
                  setmodalvalue(false);
                  props.cancelEdit();
                }}
                component={"Posting"}
              />
            </form>
          </div>
        </div>
      </div>
    );
  };

  return (
    <Dialog
      title={"Edit Posting"}
      onClose={props.cancelEdit}
      className="dialog-xmd"
    >
      {EditPostingContent()}
      <DialogActionsBar>
        <div className={`float-end w-100 dialog-footer`}>
          <Button
            className="common-btn bgBtnSecondary me-3"
            type="button"
            onClick={() => {
              //   resetfields();
              props.cancelEdit();
            }}
          >
            Cancel
          </Button>
          <Button
            className="common-btn me-3"
            type="submit"
            id="chit-request-post"
            onClick={handlesubmit}
          >
            Update
          </Button>
        </div>
      </DialogActionsBar>
    </Dialog>
  );
};
export default EditPosting;
